module.exports = __webpack_public_path__ + "images/index/img05.ae676fc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/children/new/img05.jpeg
// module id = tp0B
// module chunks = 21